import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

export interface ProfileSetupState {
  loading: boolean;
  needsSetup: boolean;
}

/**
 * Detecta perfis criados via login social (Google/Apple) que ainda não
 * informaram tipo de perfil, telefone e cidade.
 */
export const useProfileSetup = (): ProfileSetupState => {
  const { user, loading: authLoading } = useAuth();
  const [loading, setLoading] = useState(true);
  const [needsSetup, setNeedsSetup] = useState(false);

  useEffect(() => {
    let active = true;
    if (authLoading) return;
    if (!user) {
      setNeedsSetup(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    supabase
      .from("profiles")
      .select("phone, city, profile_setup_completed")
      .eq("user_id", user.id)
      .maybeSingle()
      .then(({ data, error }) => {
        if (!active) return;
        if (error || !data) {
          setNeedsSetup(false);
        } else {
          const row = data as unknown as { phone: string | null; city: string | null; profile_setup_completed: boolean | null };
          const missing = !row.phone?.trim() || !row.city?.trim();
          setNeedsSetup(missing || row.profile_setup_completed === false);
        }
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [user, authLoading]);

  return { loading: authLoading || loading, needsSetup };
};
